<template>
    <v-container fuid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12 md4>
                <v-card class="elevation-12">
                    <v-toolbar color="primary">
                        <v-toolbar-title>{{ $t('logIn') }}</v-toolbar-title>
                    </v-toolbar>
                    <v-form @submit.prevent="logIn">
                        <v-card-text>
                            <v-alert type="error" :value="authFailure">{{ $t('wrongLoginPass') }}</v-alert>
                            <v-alert type="error" :value="connectionError">{{ $t('connectionError') }}</v-alert>
                            <v-alert type="error" :value="inactiveUser">{{ $t('inactiveUser') }}</v-alert>
                            <v-text-field prepend-icon="person" name="email" :label="$t('email')" type="text" v-model="email" required></v-text-field>
                            <v-text-field 
                                prepend-icon="lock"
                                name="password" :label="$t('password')" id="password" required
                                :type="passHidden ? 'password' : 'text'"
                                v-model="password"
                                :append-icon="passHidden ? 'visibility' : 'visibility_off'"
                                @click:append="() => (passHidden = !passHidden)">
                            </v-text-field>
                        </v-card-text>
                        <v-card-actions>
                            <v-card-text>
                                v1.5
                            </v-card-text>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" type="submit" :loading="isLoading" :disabled="isLoading">{{ $t('logIn') }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            email: null,
            password: null,
            passHidden: true,

            authFailure: false,
            connectionError: false,
            inactiveUser: false,
        };
    },

    methods: {
        logIn() {
            this.authFailure = false
            this.connectionError = false
            this.inactiveUser = false
            this.$store.dispatch('login', {
                email: this.email,
                password: this.password
            })
            .catch((error) => {
                if(!error.response){ //Connection error (CORS?)
                    this.connectionError = true
                }else if(error.response.status == 404){ //Bad user
                    this.authFailure = true
                }else if(error.response.status == 401){ //Bad password
                    this.authFailure = true
                }else if(error.response.status == 403){ //Inactive user
                    this.inactiveUser = true
                }
            });
        },
    },

    computed: mapGetters([
        'isLoading',
    ]),
};
</script>
